import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowsClockwise = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Icons / 16px / ArrowsClockwise",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M11.0127 6.23145H14.0127V3.23145",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M4.1123 4.1124C4.62255 3.60141 5.22853 3.19603 5.89559 2.91944C6.56264 2.64285 7.27768 2.50049 7.9998 2.50049C8.72193 2.50049 9.43697 2.64285 10.104 2.91944C10.7711 3.19603 11.3771 3.60141 11.8873 4.1124L14.0123 6.23115",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M4.9873 9.76855H1.9873V12.7686",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_4",
				d: "M11.8873 11.8873C11.3771 12.3983 10.7711 12.8037 10.104 13.0803C9.43697 13.3569 8.72193 13.4992 7.9998 13.4992C7.27768 13.4992 6.56264 13.3569 5.89559 13.0803C5.22853 12.8037 4.62255 12.3983 4.1123 11.8873L1.9873 9.76855",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgArrowsClockwise;
